import { theme } from '@revenuemarket/design';

import { ModalAlertType } from '../types/modal';

export function getIconColor(alertType?: ModalAlertType) {
  switch (alertType) {
    case 'danger':
      return theme.colors.red800;
    default:
      return theme.semanticColors.warning.regular;
  }
}
